export default {
  "home.start_now": "Start Now",
  "home.tips.all_free": "All free",
  "home.tips.no_download_required": "No download required",
  "home.tips.no_payment_required": "No payment required",
  "home.tips.no_registration_required": "No registration required",
  "home.tips.no_subscription_required": "No subscription required",
  "home.welcome_to": "Welcome to",
};
